import Counter from "../Components/Counter"
import MilIllustrationSlider from "../Components/MilIllustrationSlider";

export default function Residental() {
    const residentealPhotos = [
    'assets/images/offer/residental/1.png',
    'assets/images/offer/residental/2.png',
    'assets/images/offer/residental/3.png',
    'assets/images/offer/residental/4.png',
    ];
    return(
      <div className="mil-wrapper">
        <div id="content">

          <section class="mil-banner mil-banner-sm">
            <img src="assets/images/background/background-4.png" class="mil-bg-img mil-scale" data-value-1=".4" data-value-2="1.4" alt="Tło budynki mieszkalne." style={{ objectPosition: "top" }} />
              <div class="container">
                <div class="mil-background-grid mil-top-space"></div>
                  <div class="mil-banner-content mil-center">
                    <div class="mil-mb-90">
                      <h1 class="mil-light mil-upper mil-mb-30">BUDOWNICTWO<br />MIESZKANIOWE</h1>
                    </div>
                  </div>
              </div>
            </section>

          <section>
                <div class="container mil-p-120-60">
                    <div class="mil-background-grid mil-softened"></div>
                    <div class="row justify-content-between">
                        <div class="col-lg-7">

                            <h2 class="mil-upper mil-up mil-mb-60">ZBUDUJEMY TWÓJ DOM<br />“POD KLUCZ”</h2>
                            <p class="mil-up mil-mb-30">Specjalizujemy się w kompleksowej realizacji domów jednorodzinnych. Rozumiemy, że budowa własnego domu to jedna z najważniejszych decyzji w życiu, dlatego podchodzimy do każdego projektu z pełnym zaangażowaniem i dbałością o detale. Naszym celem jest przeprowadzenie Cię przez cały proces – od pierwszej koncepcji po odbiór kluczy – w sposób sprawny, transparentny i bezstresowy. Nawet jeśli nie posiadasz gotowego projektu, nie stanowi to problemu. Współpracujemy z doświadczonymi architektami, którzy pomogą przekuć Twoje marzenia w realny plan.</p>
                            
                            <div class="mil-divider-lg mil-up mil-mb-60"></div>

                            <h3 class="mil-upper mil-up mil-mb-60">Proces budowy Twojego domu</h3>
                            
                            <div class="col-lg-12">
                              <div class="d-flex align-items-center mil-mb-15">
                                <div class="flex-shrink-0">
                                  <img src="assets/images/icons/01.png" alt="01 numer" style={{ width:"70px"}} />
                                </div>
                                <div class="flex-grow-1 ms-3" >
                                  <h5>Koncepcja, projekt i wycena</h5>
                                  <p>Spotykamy się, aby omówić Twoje potrzeby i wizję. Jeśli nie masz projektu, łączymy Cię z naszym architektem. Na podstawie gotowego planu tworzymy szczegółową, transparentną wycenę i harmonogram prac.</p>
                                </div>
                              </div>
                              <div class="d-flex align-items-center mil-mb-15" >
                                <div class="flex-shrink-0">
                                  <img src="assets/images/icons/02.png" alt="02 numer" style={{ width:"70px"}} />
                                </div>
                                <div class="flex-grow-1 ms-3" >
                                  <h5>Stan surowy zamknięty</h5>
                                  <p>To kluczowy etap, który obejmuje wykonanie fundamentów, wzniesienie ścian, stropów oraz konstrukcję dachu wraz z pokryciem i montażem okien. Twój dom nabiera realnych kształtów.</p>
                                </div>
                              </div>
                              <div class="d-flex align-items-center mil-mb-15">
                                <div class="flex-shrink-0">
                                  <img src="assets/images/icons/03.png" alt="03 numer" style={{ width:"70px"}} />
                                </div>
                                <div class="flex-grow-1 ms-3">
                                  <h5>Prace instalacyjne i wykończeniowe</h5>
                                  <p>Wykonujemy wszystkie niezbędne instalacje (elektryczne, wodno-kanalizacyjne, grzewcze), a następnie przechodzimy do tynkowania, wylewania posadzek i prac wykończeniowych zgodnie z ustaleniami.</p>
                                </div>
                              </div>
                              <div class="d-flex align-items-center mil-mb-15">
                                <div class="flex-shrink-0">
                                  <img src="assets/images/icons/04.png" alt="04 numer" style={{ width:"70px"}} />
                                </div>
                                <div class="flex-grow-1 ms-3">
                                  <h5>Odbiory i przekazanie kluczy</h5>
                                  <p>Po zakończeniu wszystkich prac, dokonujemy finalnych szlifów i przeprowadzamy odbiory techniczne. Zwieńczeniem naszej współpracy jest uroczyste przekazanie Ci kluczy do Twojego wymarzonego domu.</p>
                                </div>
                              </div>
                              
                            </div>


                        </div>
                        <div class="col-lg-5">

                            <div class="mil-sidebar-frame mil-mb-60">
                                <h2 class="mil-upper mil-up mil-mb-60">Inne usługi</h2>
                                <p class="mil-dark mil-mb-5">Budownictwo wielorodzinne</p>
                                <p class="mil-dark mil-mb-5">Budownictwo usługowo - przemysłowe</p>
                                <p class="mil-dark mil-mb-30">Realizacje</p>
                                
                                <div class="mil-divider-lg mil-up mil-mb-30"></div>

                                <div class="row sc-p-txt">
                                    <div class="col-6">
                                        <div class="mil-counter-frame mil-up mil-mb-30">
                                            <h5 class="mil-mb-5 mil-accent">
                                               <Counter target={1000} />+
                                            </h5>
                                            <p class="mil-dark">Wykonanych zleceń</p>
                                        </div>
                                    </div>
                                    <div class="col-6">

                                        <div class="mil-counter-frame mil-up mil-mb-30">
                                            <h5 class="mil-mb-5 mil-accent">
                                               <Counter target={30} />+
                                            </h5>
                                            <p class="mil-dark">Doświadczonych pracowników</p>
                                        </div>

                                    </div>
                                    <div class="col-6">

                                        <div class="mil-counter-frame mil-up mil-mb-30">
                                             <h5 class="mil-mb-5 mil-accent">
                                               <Counter target={10} />+
                                            </h5>
                                            <p class="mil-dark">Lat doświadczenia</p>
                                        </div>

                                    </div>
                                    <div class="col-6">

                                        <div class="mil-counter-frame mil-up mil-mb-30">
                                            <h5 class="mil-mb-5 mil-accent">
                                               <Counter target={50000} />+
                                            </h5>
                                            <p class="mil-dark">Godzin <br />pracy</p>
                                        </div>

                                    </div>
                                </div>

                                <div class="mil-divider-lg mil-up mil-mb-30"></div>

                                <h6 class="mil-upper mil-up mil-mb-30">Kontakt</h6>
                                <p class="mil-dark mil-mb-30">Zapraszamy do kontaktu:<br />Pon - Piąt: 8:00 - 17:00</p>
                                <p class="mil-dark mil-mb-5">Waryńskiego 33/2, 87-100 Toruń</p>
                                <p class="mil-dark mil-mb-5">+48 534 727 286</p>
                                <p class="mil-dark mil-mb-5">biuro@holtyn-bud.pl</p>
                            </div>
                        </div>
                    </div>
                </div>
          </section>

          <section>
                <div class="container mil-p-120-90">
                    <div class="mil-background-grid mil-softened"></div>

                    <div class="mil-center mil-mb-90">
                        <h2 class="mil-upper mil-up">ZAKRES NASZYCH PRAC</h2>
                    </div>

                    <div class="row">
                        <div class="col-lg-4 mil-up">

                            <div  class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Prace ziemne<br />i fundamentowe</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Przygotowanie terenu, wykopy i solidne fundamenty.</p> 
                                </div>
                            </div>

                        </div>
                        <div class="col-lg-4 mil-up">
                            <div class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Prace murarskie <br/>i żelbetowe</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Wznoszenie ścian nośnych, działowych i stropów.</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 mil-up">
                            <div class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Konstrukcje<br/>i pokrycia dachowe</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Kompleksowe dekarstwo, od więźby po poszycie.</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 mil-up">
                            <div class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Termoizolacje <br/>budynków</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Ocieplenia ścian i dachów dla komfortu i oszczędności.</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 mil-up">
                            <div class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Stolarka okienna <br/>i drzwiowa</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Montaż okien, drzwi zewnętrznych i bram garażowych.</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 mil-up">
                            <div class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Tynkowanie <br/>i wykończenia</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Tynki, gładzie, posadzki i prace malarskie.</p>
                                    
                                </div>
                            </div>
                        </div>

                        </div>
                    </div>
        </section>

        <MilIllustrationSlider images={residentealPhotos} />;

        </div>
      </div>
    )
}